import React from 'react';
import PropTypes from 'prop-types';
import Constants from '../../config/const';
import * as classes from './classes.module.scss';

const { whitePos } = Constants.silhouette;

const WhiteBg = ({
  posX, posY, centerX, centerY, dpi, silhouetteY
}) => {
  const screenHeight = (centerY - posY) * 2;
  const screenWidth = (centerX - posX) * 2;

  const wTop = silhouetteY + whitePos;

  if (posY + screenHeight < wTop) {
    return null;
  }

  // const whitePosTop = wTop - posY;
  const whitePosLeft = posX;
  const whitePosRight = whitePosLeft + screenWidth;

  const style = {
    top: wTop * dpi,
    height: '100%',
    left: whitePosLeft * dpi,
    right: whitePosRight * dpi
  };
  return (
    <div style={ style } className={ classes.whiteBg } />
  );
};

WhiteBg.propTypes = {
  dpi: PropTypes.number.isRequired,
  posX: PropTypes.number.isRequired,
  posY: PropTypes.number.isRequired,
  centerX: PropTypes.number.isRequired,
  centerY: PropTypes.number.isRequired,
  silhouetteY: PropTypes.number.isRequired
};

export default WhiteBg;
